<template>
<w-sliding-popup ref="slidingPopup" title="대상 선택" width="700px" :defaultContent="false" class="object-select-popup" @close="closed">
  <div slot="content" class="content-wrapper">
    <div class="list form-list">
      <el-form label-position="left" label-width="60px">
        <el-form-item label="조회기준" v-if="options.selectObjTypeOpts.enabled">
          <el-radio-group v-model="selectedInfo.selectedObjType" @change="onChangeSelectObjType">
            <el-radio label="single">단일대상 / 다중자원</el-radio>
            <el-radio label="multi">다중대상 / 단일자원</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="관리구분" v-if="options.managetypeOpts.enabled">
          <div class="object__wrapper"  v-if="options.managetypeOpts.isMultiple">
            <div class="checkbox__wrapper end" v-if="options.managetypeOpts.totalEnabled">
              <el-checkbox v-model="selectedInfo.managetypeTotal">전체</el-checkbox>
            </div>
            <el-scrollbar class="dashboard-object-tree__wrapper">
              <w-managetype-table ref="managetypeTable" :managetype-info="selectedInfo.managetypeIds" :is-multiple="true" :disabled="selectedInfo.managetypeTotal"/>
            </el-scrollbar>
          </div>
          <el-select ref="managetypeSelect" v-else v-model="selectedInfo.managetypeId" placeholder="Select" @change="onChangeManagetypeId" style="width: 150px;">
            <el-option v-for="item in managetypeIdList" :key="item.managetypeId" :label="item.managetypeName" :value="item.managetypeId">
            </el-option>
          </el-select>
          <el-select ref="managetypekeySelect" v-if="!options.managetypeOpts.isMultiple" v-model="selectedInfo.managetypeKey" placeholder="Select" :disabled="isManagetypeDisable" @change="onChangeManagetypeKey" style="width: 140px;">
            <el-option v-for="item in managetypeKeyList" :key="item.managetypeKey" :label="item.managetypeKeyName" :value="item.managetypeKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="objectLabel" v-if="options.objOpts.enabled">
          <div class="object__wrapper">
            <div class="checkbox__wrapper end" v-if="options.objOpts.isMultiple && options.objOpts.totalEnabled">
              <el-checkbox v-model="objectTotal">전체</el-checkbox>
            </div>
            <w-obj-select-tree ref="objTree" :selectedNode.sync="selectedObj" :treeDataType="options.objOpts.treeDataType" :isMultiple="options.objOpts.isMultiple" :disabled="selectedInfo.objTotal || selectedInfo.managegroupTotal" selectScope="leaf"/>
          </div>
        </el-form-item>
        <el-form-item label="관리자원" v-if="options.rscOpts.enabled">
          <div class="object__wrapper">
            <div class="checkbox__wrapper end" v-if="options.rscOpts.isMultiple && options.rscOpts.totalEnabled">
              <el-checkbox v-model="selectedInfo.rscTotal" v-if="options.rscOpts.isMultiple">전체</el-checkbox>
            </div>
            <w-rsc-select-tree ref="rscTree" :selectedNode.sync="selectedRsc" :isMultiple="options.rscOpts.isMultiple" :isMultipleUnit="options.rscOpts.isMultipleUnit" :disabled="selectedInfo.rscTotal" selectScope="leaf"/>
          </div>
        </el-form-item>
        <el-form-item label="관리자원키" v-if="options.rscKeyOpts.enabled">
          <div :class="['object__wrapper', 'table']">
            <div class="checkbox__wrapper btn-bar between mr-b5">
              <el-button @click="onRscKeyLoadClick"><i class="far fa-sync-alt"></i></el-button>
              <el-checkbox v-model="selectedInfo.rscKeyTotal">전체</el-checkbox>
            </div>
            <w-rsc-key-select-table :disabled="selectedInfo.rscKeyTotal" :selectedData.sync="selectedRscKey" ref="rscKeyTable"/>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
  <div slot="footer">
    <el-button size="large" type="solid" @click="onSaveClick">저장</el-button>
    <el-button size="large" @click="close">취소</el-button>
  </div>
</w-sliding-popup>
</template>

<script>
import WObjSelectTree from '@/views/dashboard/widgets/coord/setting/components/ObjSelectTree';
import WRscSelectTree from '@/views/dashboard/widgets/coord/setting/components/RscSelectTree';
import WRscKeySelectTable from '@/views/dashboard/widgets/coord/setting/components/RscKeySelectTable';
import WManagetypeTable from '@/views/dashboard/widgets/grid/setting/components/ManagetypeTable';
import DashboardConst from '@/constants/dashboard';
import ManagetypeAPI from '@/api/model/managetype';
import ManagetypeKeyAPI from '@/api/model/managetype-key';
import { isEmpty } from '@/utils/basic';

export default {
  name: 'WObejctSelectPopup',
  components: {
    WObjSelectTree,
    WRscSelectTree,
    WRscKeySelectTable,
    WManagetypeTable,
  },
  data() {
    return {
      options: {
        selectObjTypeOpts: {
          enabled: true,
        },
        managetypeOpts: {
          isMultiple: true,
          totalEnabled: true,
        },
        objOpts: {
          enabled: false,
          treeDataType: 'node',
          isMultiple: true,
          totalEnabled: true,
        },
        rscOpts: {
          enabled: false,
          isMultiple: true,
          isMultipleUnit: false,
          totalEnabled: true,
        },
        rscKeyOpts: {
          enabled: false,
          isMultiple: true,
        },
      },
      selectedInfo: {
        selectedObjType: 'single',
        managetypeId: '',
        managetypeIds: [],
        managetypeTotal: false,
        managetypeKey: '',
        objTotal: false,
        objIds: [],
        objTreeKeys: [],
        rscTotal: false,
        rscInfoList: [],
        rscTreeKeys: [],
        rscKeyInfoList: [],
        selectedLabel: '',
        managetypeLabel: '',
        objLabel: '',
        rscLabel: '',
        rscKeyLabel: '',
        rscKeyTotal: false,
      },
      selectedObj: [],
      selectedRsc: [],
      selectedRscKey: [],
      managetypeIdList: [],
      managetypeKeyList: [],
      defaultManagetypeKeyList: [{ managetypeKeyName: 'Total', managetypeKey: '_' }],
      originalSelectedInfo: {
        managetypeId: '',
        managetypeKey: '',
      },
    };
  },
  computed: {
    isManagetypeDisable() {
      const managetypeId = this.selectedInfo.managetypeId;
      if (managetypeId === 'NMS' || managetypeId === 'FMS' || managetypeId === 'DBMS' || managetypeId === 'VMS') {
        return false;
      }
      return true;
    },
    objectLabel() {
      return (this.options.objOpts.treeDataType === 'node') ? '관리대상' : '관리그룹';
    },
    objectTotal: {
      get() {
        if (this.options.objOpts.treeDataType === 'node') {
          return this.selectedInfo.objTotal;
        }
        return this.selectedInfo.managegroupTotal;
      },
      set(value) {
        if (this.options.objOpts.treeDataType === 'node') {
          this.selectedInfo.objTotal = value;
        } else {
          this.selectedInfo.managegroupTotal = value;
        }
      },
    },
  },
  watch: {
    selectedObj(value) {
      if (!isEmpty(value)) {
        const { nodes, treeKeys } = value;
        if (this.options.objOpts.treeDataType === 'node') {
          const objIds = [];
          const objs = [];
          nodes.forEach((node) => {
            objs.push(node.obj);
            objIds.push(isEmpty(node.obj) ? node.objId : node.obj.objId);
          });
          this.selectedInfo.objs = objs;
          this.selectedInfo.objIds = objIds;
          this.selectedInfo.objTreeKeys = treeKeys;
          // if (this.options.rscOpts.enabled) {
          //   this.setRscKeyTable();
          // }
        } else if (this.options.objOpts.treeDataType === 'group') {
          const managegroupIds = [];
          nodes.forEach((node) => {
            managegroupIds.push(node.managegroupId);
          });
          this.selectedInfo.managegroupIds = managegroupIds;
          this.selectedInfo.groupTreeKeys = treeKeys;
        }
      }
    },
    selectedRsc(value) {
      if (!isEmpty(value)) {
        const { nodes, treeKeys } = value;
        const rscInfoList = [];
        nodes.forEach((node) => {
          rscInfoList.push({
            rsctypeId: node.rsctypeId,
            rscId: node.rscId,
          });
        });
        this.selectedInfo.rscInfoList = rscInfoList;
        this.selectedInfo.rscTreeKeys = treeKeys;
      }
      if (isEmpty(value.nodes) && this.options.rscOpts.enabled && !isEmpty(this.$refs.rscKeyTable)) {
        this.$refs.rscKeyTable.initData();
      }
    },
    selectedRscKey(value) {
      if (!isEmpty(value)) {
        const rscKeyInfoList = [];
        value.forEach((node) => {
          rscKeyInfoList.push({
            rscKey: node.rscKey,
          });
        });
        this.selectedInfo.rscKeyInfoList = rscKeyInfoList;
      }
    },
    objTreeType() {
      return (this.selectedInfo.selectedObjType === 'single') ? 'uncheck' : 'check';
    },
    rscTreeType() {
      return (this.selectedInfo.selectedObjType === 'single') ? 'check' : 'uncheck';
    },
    isObjDisable() {
      return (this.selectedInfo.objTotal && this.selectedInfo.selectedObjType === 'multi');
    },
  },
  created() {
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.OBJECT_SELECT, this.open);
  },
  beforeDestroy() {
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.OBJECT_SELECT, this.open);
  },
  methods: {
    open(datas) {
      Object.assign(this.options, datas.options);
      this.initData(datas.selectedInfo);
      this.originalSelectedInfo = datas.originalSelectedInfo;
      this.loadData();
      this.$nextTick(() => {
        this.$refs.slidingPopup.open();
      });
    },
    close() {
      this.$refs.slidingPopup.close();
    },
    closed() {
      if (this.$refs.objTree) {
        this.$refs.objTree.$refs.searchField.clear();
      }

      if (this.$refs.rscTree) {
        this.$refs.rscTree.$refs.searchField.clear();
      }
    },
    initData(selectedInfo) {
      this.selectedInfo = selectedInfo;
      this.selectedObj = [];
      if (this.options.rscOpts.enabled) {
        this.selectedRsc = [];
        this.selectedRscKey = [];
      }
      this.managetypeIdList = [];
      this.managetypeKeyList = [];
    },
    loadData() {
      ManagetypeAPI.getActiveManagetypeList().then((response) => {
        this.setManagetypeIdList(response.data.data);
        this.setManagetypeKey(this.selectedInfo.managetypeId, false);
        // this.setObjRscKey();
        this.$refs.objTree.loadData(this.selectedInfo.dataViewPointType === DashboardConst.OPTIONS.DATA_VIEWPOINT_TYPE.PREDICT);
        this.$nextTick(() => {
          this.$refs.objTree.setDefaultNodeByTreeKey((this.options.objOpts.treeDataType === 'node') ? this.selectedInfo.objTreeKeys : this.selectedInfo.groupTreeKeys, this.originalSelectedInfo);
          if (this.options.rscOpts.enabled) {
            this.$refs.rscTree.setDefaultNodeByTreeKey(this.selectedInfo.rscTreeKeys);
            if (!isEmpty(this.selectedInfo.rscInfoList)) {
              this.setRscKeyTable();
            }
          }
        });
      });
    },
    setManagetypeIdList(newManagetypeIdList) {
      if (isEmpty(newManagetypeIdList)) {
        this.managetypeIdList = [];
      }
      this.managetypeIdList = newManagetypeIdList.filter((data) => data.managetypeId !== 'COMMON');
      if (isEmpty(this.selectedInfo.managetypeId)) {
        this.selectedInfo.managetypeId = this.managetypeIdList[0].value;
      }
      if (this.options.rscOpts.enabled) {
        this.setRscTree();
      }
    },
    setManagetypeKey(newVal, isChange) {
      if (isEmpty(newVal)) { // 이벤트그리드위젯 설정> 데이터> 조회대상선택 클릭 시 오류를 방지하기 위한 분기 처리
        return;
      }
      if (newVal === 'NMS' || newVal === 'FMS' || newVal === 'DBMS' || newVal === 'VMS') {
        ManagetypeKeyAPI.getDisplayedManagetypeKeyList(newVal).then((response) => {
          if (response.data.success) {
            const data = response.data.data;
            this.managetypeKeyList = (newVal === 'VMS') ? data.filter((v) => v.managetypeKey !== '_') : data;
            if (!isChange && !isEmpty(this.selectedInfo.managetypeKey)) {
              this.selectedInfo.managetypeKey = this.selectedInfo.managetypeKey;
            } else {
              this.selectedInfo.managetypeKey = this.managetypeKeyList[0].managetypeKey;
            }
            this.$nextTick(() => {
              this.setRscTree();
              this.setObjTree();
            });
          }
        });
      } else {
        this.managetypeKeyList = this.defaultManagetypeKeyList;
        if (isChange && isEmpty(this.selectedInfo.managetypeKey)) {
          this.selectedInfo.managetypeKey = this.managetypeKeyList[0].managetypeKey;
        }
        this.$nextTick(() => {
          this.setRscTree();
          this.setObjTree();
        });
      }
    },
    onChangeSelectObjType(value) {
      this.options.objOpts.isMultiple = (value === 'multi');
      this.$refs.objTree.initTreeData();
      this.$refs.objTree.setTreeData();
      if (this.options.rscOpts.enabled) {
        this.options.rscOpts.isMultiple = (value === 'single');
        this.$refs.rscTree.initTreeData();
        this.$refs.rscTree.loadData({
          managetypeId: this.selectedInfo.managetypeId,
          managetypeKey: this.selectedInfo.managetypeKey,
          isPredict: this.selectedInfo.dataViewPointType === DashboardConst.OPTIONS.DATA_VIEWPOINT_TYPE.PREDICT,
        });
      }
      // if (this.options.rscKeyOpts.enabled) {
      //   this.setRscKeyTable();
      // }
    },
    onChangeManagetypeId() {
      this.objIds = [];
      this.objKeys = [];
      this.selectedInfo.managetypeKey = null;
      this.setManagetypeKey(this.selectedInfo.managetypeId, true);
      this.$nextTick(() => {
        this.setObjTree();
      });
    },
    onChangeManagetypeKey() {
      this.setObjTree();
      this.setRscTree();
    },
    setObjTree() {
      // this.$refs.objTree.loadData();
      if (this.$refs.objTree) {
        this.$refs.objTree.initTreeData();
        this.$nextTick(() => {
          this.$refs.objTree.setTreeData({
            managetypeId: this.selectedInfo.managetypeId,
            managetypeKey: this.selectedInfo.managetypeKey,
          });
        });
      }
    },
    setRscTree() {
      if (this.$refs.rscTree) {
        this.$refs.rscTree.initTreeData();
        this.$nextTick(() => {
          this.$refs.rscTree.loadData({
            managetypeId: this.selectedInfo.managetypeId,
            managetypeKey: this.selectedInfo.managetypeKey,
            isPredict: this.selectedInfo.dataViewPointType === DashboardConst.OPTIONS.DATA_VIEWPOINT_TYPE.PREDICT
          });
        });
      }
    },
    setRscKeyTable() {
      if (!isEmpty(this.$refs.objTree) || !isEmpty(this.$refs.rscTree)) {
        const currentObjIds = (this.options.objOpts.treeDataType === 'node') ? this.selectedInfo.objIds : this.selectedInfo.managegroupIds;
        const currentRsctypeIds = this.selectedInfo.rscInfoList.reduce((accumulator, value) => {
          accumulator.push(value.rsctypeId);
          return accumulator;
        }, []);
        const currentRscIds = this.selectedInfo.rscInfoList.reduce((accumulator, value) => {
          accumulator.push(value.rscId);
          return accumulator;
        }, []);
        if (isEmpty(currentObjIds) || isEmpty(currentRsctypeIds) || isEmpty(currentRscIds)) {
          this.$refs.rscKeyTable.initData();
          return;
        }
        const rscKeyParams = {
          managetypeId: this.selectedInfo.managetypeId,
          objIds: currentObjIds,
          rsctypeIds: currentRsctypeIds,
          rscIds: currentRscIds,
          rscKeyInfo: this.selectedInfo.rscKeyInfoList,
        };
        this.$nextTick(() => {
          this.$refs.rscKeyTable.loadData(rscKeyParams);
        });
      }
    },
    onRscKeyLoadClick() {
      if (this.options.rscOpts.enabled) {
        this.setRscKeyTable();
      }
    },
    onSaveClick() {
      if (this.options.selectObjTypeOpts.enabled) {
        this.selectedInfo.selectedLabel = (this.selectedInfo.selectedObjType === 'single') ? '단일대상 / 다중자원' : '다중대상 / 단일자원';
      }

      if (this.options.managetypeOpts.enabled) {
        let managetypeLabel = '';
        if (this.options.managetypeOpts.isMultiple) {
          const selectedManagetype = this.$refs.managetypeTable.getCurruntData();
          managetypeLabel = isEmpty(selectedManagetype) ? '' : selectedManagetype[0].managetypeName;
          if (!isEmpty(selectedManagetype) && selectedManagetype.length > 1) {
            managetypeLabel += ` 외 ${selectedManagetype.length - 1}개`;
          }
          this.selectedInfo.managetypeIds = [];
          selectedManagetype.forEach((managetypeInfo) => {
            this.selectedInfo.managetypeIds.push(managetypeInfo.managetypeId);
          });
        } else {
          managetypeLabel = `${this.$refs.managetypeSelect.selectedLabel}${(this.$refs.managetypekeySelect.selectedLabel === 'Total') ? '' : ` / ${this.$refs.managetypekeySelect.selectedLabel}`}`;
        }
  
        if (this.options.managetypeOpts.totalEnabled && this.selectedInfo.managetypeTotal) {
          managetypeLabel = '전체';
        }
        this.selectedInfo.managetypeLabel = managetypeLabel;
      }

      let objLabel = '';
      const selectedObj = isEmpty(this.selectedObj) ? this.$refs.objTree.getCurrentNode() : this.selectedObj;
      if (this.options.objOpts.treeDataType === 'node') {
        objLabel = isEmpty(selectedObj.nodes) ? '' : `${isEmpty(selectedObj.nodes[0].obj) ? selectedObj.nodes[0].label : selectedObj.nodes[0].obj.objName}`;
        if (!isEmpty(selectedObj.nodes) && selectedObj.nodes.length > 1) {
          objLabel += ` 외 ${selectedObj.nodes.length - 1}개`;
        }
      } else if (this.options.objOpts.treeDataType === 'group') {
        objLabel = isEmpty(selectedObj.nodes) ? '' : `${selectedObj.nodes[0].label}`;
        if (!isEmpty(selectedObj.nodes) && selectedObj.nodes.length > 1) {
          objLabel += ` 외 ${selectedObj.nodes.length - 1}개`;
        }
      }

      if (this.options.objOpts.totalEnabled && this.objectTotal) {
        objLabel = '전체';
      }

      this.selectedInfo.objLabel = objLabel;

      if (this.options.rscOpts.enabled) {
        const selectedRsc = isEmpty(this.selectedRsc) ? this.$refs.rscTree.getCurrentNode() : this.selectedRsc;
        let rscLabel = isEmpty(selectedRsc.nodes) ? '' : `${selectedRsc.nodes[0].rsctypeName} > ${selectedRsc.nodes[0].rscName}`;
        if (!isEmpty(selectedRsc.nodes) && selectedRsc.nodes.length > 1) {
          rscLabel += ` 외 ${selectedRsc.nodes.length - 1}개`;
        }

        if (this.options.rscOpts.totalEnabled && this.selectedInfo.rscTotal) {
          rscLabel = '전체';
        }
        const selectedRscKey = isEmpty(this.selectedRscKey) ? this.$refs.rscKeyTable.getCurruntData() : this.selectedRscKey;
        let rscKeyLabel = isEmpty(selectedRscKey) ? '' : `${selectedRscKey[0].valueName}`;
        if (!isEmpty(selectedRscKey) && selectedRscKey.length > 1) {
          rscKeyLabel += ` 외 ${selectedRscKey.length - 1}개`;
        }
        if (this.options.rscKeyOpts.totalEnabled && this.selectedInfo.rscKeyTotal) {
          rscKeyLabel = '전체';
        }
        this.selectedInfo.rscLabel = rscLabel;
        this.selectedInfo.rscKeyLabel = rscKeyLabel;
      }
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.CHANGE_SELECTED_INFO, this.selectedInfo);
      this.close();
    },
  },
};
</script>

<style lang="scss">
.object-select-popup {
  overflow-x: hidden;
  .content-wrapper {
    overflow-x: hidden;
    height: 100%;
    padding: 10px 10px 20px 10px;
    .object__wrapper {
      height: 250px;
      overflow-y: hidden;
      border: 1px solid #e7e7e7;
      &.table {
        padding: 5px 5px 5px 5px;
        height: 145px;
        .el-scrollbar__view {
          height: 100%;
        }
      }
      .checkbox__wrapper {
        display: flex;
        &.btn-bar {
          .el-checkbox {
            top: 5px;
          }
        }
        &.between {
          justify-content: space-between;
        }
        &.end {
          padding: 5px 8px 0 0;
          justify-content: flex-end;
        }
      }
      .dashboard-object-tree__wrapper {
        .el-scrollbar__view {
          height: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/popup/ObjectSelectPopup.vue